export default {"src":"/_next/static/media/op-operator.920bcaec.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};